import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Dropdown } from 'primereact/dropdown';
import { Api } from '../../../services/api';
import { FaCopy, FaTrash } from 'react-icons/fa';
import { BiPlusMedical } from 'react-icons/bi';

const Config = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [projectType, setProjectType] = useState([]);
    const [searchProjectType, setSearchProjectType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState('');

    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

    // -------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    // -------------------------------------------------------------

    const formik = useFormik({
        initialValues: {
            QbProjectName: '',
            ProjectId: '',

        },

        validate: (data) => {
            let errors = {};

            if (!data.QbProjectName) {
                errors.QbProjectName = 'QB Project Name is required.';
            } if (!data.ProjectId) {
                errors.ProjectId = 'Please Select a Project.';
            }
            return errors;
        },

        onSubmit: (data) => {
            const token = localStorage.getItem('authToken');
            const headers = {
                'Authorization': token ? `Bearer ${token}` : '',
                "Content-Type": "application/json",
            };


            // var url = API_BASE_URL + 'get-all-qb-project-add';
            var url = Api.API_BASE_URL + 'get-all-qb-project-add';
            if (type == "Edit") {
                // url = API_BASE_URL + 'get-all-qb-project-update/' + projectTypeID;
                url = Api.API_BASE_URL + 'get-all-qb-project-update/' + projectTypeID;
            }


            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        closeModal();
                        getProjectType();
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            console.log(data);
        }
    });
    // -------------------------------------------------------------




    const [pageNumber, setPageNumber] = useState(0);
    const projectsPerPage = 5;
    const pagesVisited = pageNumber * projectsPerPage;

    const pageCount = Math.ceil(projectType.length / projectsPerPage);

    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };

    const displayedProjects = projectType.slice(pagesVisited, pagesVisited + projectsPerPage);


    const [type, setType] = useState('Add');
    const [title, setTitle] = useState('Add Project Type');
    const [project, setProject] = useState();
    const [projectTypeID, setProjectTypeID] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);


    const openModal = () => {
        setProjectTypeID('');
        formik.resetForm();
        setType('Add');
        setTitle('Add Project Type');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
    };



    const editModal = (row) => {
        setProjectTypeID(row.Qbid);
        formik.setFieldValue('QbProjectName', row.QbProjectName);
        formik.setFieldValue('ProjectId', row.ProjectId);

        setType('Edit');
        setTitle('Edit Project Type');
        setIsModalOpen(true);
    };

    const openCopyModal = (row) => {
        formik.setFieldValue('QbProjectName', row.QbProjectName);
        formik.setFieldValue('ProjectId', row.ProjectId);
        setType('Add');
        setTitle('Copy Project Type');
        setIsModalOpen(true);
    };


    useEffect(() => {
        console.log('Fetching projects...xx');
        getProjectType();
        // console.log(getProjectType());
    }, []);

    const getProjectType = (project) => {

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };

        axios.get(Api.API_BASE_URL + 'get-all-qb-project', { headers })
            .then((response) => {

                var data = response.data.result;
                setProjectType(data);
                setSearchProjectType(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });
        axios.get(Api.API_BASE_URL + 'get-all-project-all', { headers })
            .then((response) => {

                var data = response.data.result;
                var t = [{ id: "0", project_name: 'Select Project' }];

                const newArray = [...t, ...data];
                console.log('data,', newArray);
                setProject(newArray);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });

    };



    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div onClick={(e) => e.stopPropagation()}>
                    <FaCopy onClick={() => openCopyModal(rowData)} style={{ marginRight: '10px', color: 'orange' }} />
                    {/* <FaPencilAlt onClick={() => editModal(rowData)} style={{ marginRight: '10px'}} /> */}
                    <FaTrash onClick={() => handleDeleteProject(rowData.Qbid)} style={{ color: 'darkred' }} />
                </div>
            </React.Fragment>
        );
    };

    const handleDeleteProject = (projectId,) => {
        setProjectTypeID(projectId);
        setIsDeleteConfirmationModalOpen(true);
    };


    const confirmDelete = async () => {
        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };

        axios.get(Api.API_BASE_URL + 'get-all-qb-project-delete/' + projectTypeID, { headers })
            .then((response) => {
                toast.current.show({ severity: 'info', summary: 'Confirmed', detail: response.data.result, life: 3000 });
                getProjectType();
                closeModal();
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    }

    const searchrole = (searchValue) => {
        console.log('searchValue', searchValue);

        setProjectType([]);
        const searchResult = searchProjectType.filter((item) =>
            item.QbProjectName.toLowerCase().includes(searchValue.toLowerCase())
        );
        setProjectType(searchResult);
        console.log(searchResult)
    }

    const header = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-2 ">
            <h4 > </h4>
            <div>
                <span className="p-input-icon-left ">
                    <InputText className="input-field" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
                </span>
                <button type="button" title='Add a new project' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
                    <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
                        <BiPlusMedical size={14} />
                        <span> ADD </span>
                    </div>
                </button>
            </div>
        </div>
    );

    const onRowSelect = (e) => {
        const rowData = e.data;
        editModal(rowData);
    };


    return (
        <>
            {/* // -------------------------------------------------------------------------------------- */}
            {/* <div style={{ textAlign: "end", padding: "10px 10px 0px" }}>
                <button type="button" className="custom-button" onClick={openModal} >
                    + ADD
                </button>
              
            </div> */}
            {/* ----------------------------------------------------------------------------------------  */}
            <div className="pagee-container mt-2">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

                        <DataTable
                            value={projectType}
                            paginator
                            rows={14}
                            key="id"
                            tableStyle={{ minWidth: '50rem', }}
                            selectionMode="single"
                            selection={selectedProduct}
                            onRowSelect={onRowSelect}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            header={header}
                            globalFilter={globalFilter}
                            scrollHeight="flex"
                        >
                            <Column key="action" body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', alignItems: 'center', textAlign: 'center' }} />

                            <Column key="qbProjectName" field="QbProjectName" header="PROJECT NAMES (QB)" />
                            <Column key="projectName" field="project_name" header="PROJECT NAMES (PRODUCTION SHEET)" />

                        </DataTable>
                    )}
                </div>
            </div>
            {/* ---------------------------------------------------------------*/}
            <Dialog header="" visible={isModalOpen} maximizable style={{ width: '30vw' }} dismissableMask="true" onHide={() => { setIsModalOpen(false); setSelectedProduct(null); }}>
                <div className='p-2'>
                    <form onSubmit={formik.handleSubmit} className="" >
                        <div className="">

                            <div className="">
                                <div className='card-heading'>
                                    <label>QB PROJECT NAMES</label>
                                </div>

                                <InputText
                                    id="QbProjectName"
                                    name="QbProjectName"
                                    value={formik.values.QbProjectName}
                                    onChange={(e) => {
                                        console.log(e.target.value);
                                        formik.setFieldValue('QbProjectName', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('QbProjectName') })} style={{ width: '100%' }}
                                />
                            </div>

                            <div className="mt-4">
                                <div className='card-heading'>
                                    <label>PROJECT NAMES</label>
                                </div>

                                <Dropdown
                                    optionValue='id'
                                    id="ProjectId"
                                    name="ProjectId"
                                    placeholder="Select a Project"
                                    options={project}
                                    optionLabel="project_name"
                                    value={formik.values.ProjectId}
                                    filter
                                    onChange={(e) => {
                                        console.log(e.value);
                                        formik.setFieldValue('ProjectId', e.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('ProjectId') })} style={{ width: '100%' }}
                                />
                            </div>

                        </div>
                        <div className="flex flex-wrap justify-content-center mt-5">
                            <Button label="Submit" type="submit" className=' customSave-button' />
                        </div>
                    </form>
                </div>
            </Dialog>

            {/* ---------------------------------------------------------------*/}

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>"Are you sure you want to delete this project? "</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Config